import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M9.39356 4.57365C10.5444 2.55416 13.4556 2.55416 14.6065 4.57365L21.4115 16.5146C22.5512 18.5146 21.1069 21 18.805 21H5.19506C2.89315 21 1.44886 18.5146 2.5886 16.5146L9.39356 4.57365ZM12 14C12.5523 14 13 13.5523 13 13V8C13 7.44771 12.5523 7 12 7C11.4477 7 11 7.44771 11 8V13C11 13.5523 11.4477 14 12 14ZM12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }